"use client";

import { useEffect, useState } from "react";
import type { WidgetInstance } from "./apollo-client";
import { evictWidgetCache } from "./evict-widget-cache";

/**
 * `true` once the BE answered a visitor request (handshake or content query) with 403
 * `WEB_MESSENGER_NOT_AVAILABLE` / `WEB_MESSENGER_DISABLED`: a DEFINITIVE "this widget is off" (owner
 * fail-closed policy). The caller hides the widget and stops everything; the key's cached config
 * is evicted so an offline reload cannot bring it back.
 */
export function useWidgetUnavailable(instance: WidgetInstance): {
  unavailable: boolean;
  /** The eviction finished. The iframe frame is removed only after this, or the page would be torn
   *  down mid-write and the cache would survive. */
  evicted: boolean;
} {
  const [unavailable, setUnavailable] = useState(false);
  const [evicted, setEvicted] = useState(false);
  useEffect(() => {
    instance.onUnavailable = () => {
      setUnavailable(true);
      void (instance.publicKey ? evictWidgetCache(instance.publicKey) : Promise.resolve()).finally(
        () => setEvicted(true),
      );
    };
    return () => {
      instance.onUnavailable = null;
    };
  }, [instance]);
  return { unavailable, evicted };
}
